
/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import { DropzoneComponent } from 'react-dropzone-component';
import "dropzone/dist/min/dropzone.min.css";
import 'react-dropzone-component/styles/filepicker.css'
import { useEffect, useState, FormEvent, SyntheticEvent } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import { Autocomplete, CircularProgress, Icon, IconButton, Popover, TextField, Typography } from "@mui/material";
import { CategoryDto, QuizDto, SubCategoryDto, Subjects, subjects, Table } from "types";
import HelpImage from "assets/images/HelpImage.png";
import { getUUIDFromKey, eraseRichText, uploadS3Handler } from 'utils/helpers';
import { getMyCategoriesPerSubjectId } from 'services/category-services';
import { createQuiz, deleteQuiz, updateQuiz } from 'services/quiz-services';
import { Auth } from 'aws-amplify';
import { Link } from 'react-router-dom';
import MDEditor from 'components/MDEditor';
import Alert from 'components/Alert';
import { getByCategory } from 'services/sub-category-services';
import { useAppContext } from 'context/app-context';

interface DropzoneType {
  removeFile: () => void;
  removeAllFiles: () => void;
  addFile: (arg0: any) => void;
  processQueue: () => void;
}

function Cards(): JSX.Element {
  const [imageDescriptionDropzone, setImageDescriptionDropzone] = useState<DropzoneType>({} as DropzoneType)
  const [audioDescriptionDropzone, setAudioDescriptionDropzone] = useState<DropzoneType>({} as DropzoneType)
  const [imageAnswerDropzone, setImageAnswerDropzone] = useState<DropzoneType>({} as DropzoneType)
  const [audioAnswerDropzone, setAudioAnswerDropzone] = useState<DropzoneType>({} as DropzoneType)

  function initDescriptionImageCallback(dropzone: any) {
    // dropzone.options.dictDefaultMessage = "Drop images here to upload";
    setImageDescriptionDropzone(dropzone)
  }

  function initAnswerImageCallback(dropzone: any) {
    // dropzone.options.dictDefaultMessage = "Drop images here to upload";
    setImageAnswerDropzone(dropzone)
  }


  function initDescriptionAudioCallback(dropzone: any) {
    setAudioDescriptionDropzone(dropzone);
  }

  function initAnswerAudioCallback(dropzone: any) {
    setAudioAnswerDropzone(dropzone);
  }

  const [subjectValue, setSubjectValue] = useState<string>('');
  const [inputSubjectValue, setSubjectInputValue] = useState<Subjects | ''>('');
  // const [gradeValue, setGradeValue] = useState<string>('');
  // const [inputGradeValue, setGradeInputValue] = useState('');
  const [data, setData] = useState({} as Table)
  const [imageDescription, setImageDescription] = useState<File>({} as File)
  const [audioDescription, setAudioDescription] = useState<File>({} as File)

  const [imageAnswer, setImageAnswer] = useState<File>({} as File)
  const [audioAnswer, setAudioAnswer] = useState<File>({} as File)

  const [categoryValue, setCategoryValue] = useState<CategoryDto>({} as CategoryDto)
  const [inputCategoryValue, setInputCategoryValue] = useState<string>('')

  const [subCategoryValue, setSubCategoryValue] = useState<SubCategoryDto | null>({} as SubCategoryDto)
  const [inputSubCategoryValue, setInputSubCategoryValue] = useState<string>('')
  const [categories, setCategories] = useState<CategoryDto[]>([] as CategoryDto[])
  const [subCategories, setSubCategories] = useState<SubCategoryDto[]>([] as SubCategoryDto[])
  const [description, setDescription] = useState<string>('')
  const [title, setTitle] = useState<string>('')
  const [answer, setAnswer] = useState<string>('')
  const [dataTableData, setDataTableData] = useState<null | Table>(null)
  const [isLoading, setIsLoading] = useState(false)
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handlePopoverClose = () => {
    setAnchorEl(null)
  }

  const popoverOpen = Boolean(anchorEl)

  // const navigate = useNavigate()

  const { quizCards, setQuizCards, handleMessage } = useAppContext()

  useEffect(() => {
    (async () => {
      setDataTableData({
        columns: [
          { Header: "searchableTitle", accessor: "searchableTitle", hidden: true },
          { Header: "Redigér", accessor: "editLink", width: "5%" },
          { Header: "Slet", accessor: "removeLink", width: "5%" },
          { Header: "titel", accessor: "title", width: "40%" },
          { Header: "Quiz-kategori", accessor: "subcategory", width: "20%" },
          { Header: "Hovedkategori", accessor: "category", width: "10%" },
          { Header: "Fag", accessor: "subject", width: "10%" },
          { Header: "Klassetrin", accessor: "grade", width: "10%" }], rows: quizCards
      })
    })()
  }, [quizCards])

  useEffect(() => {
    if (dataTableData) {
      setData({
        ...dataTableData, rows: dataTableData.rows.map((dt) => ({
          ...dt, subcategory: dt.subcategory.name, category: dt.category.name, subject: dt.category.subject, grade: dt.subcategory.grade,
          // eslint-disable-next-line jsx-a11y/anchor-is-valid
          categoryPk: dt.category, title: <div title={dt.title} style={{ whiteSpace: 'nowrap', width: '15em', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            <Link to={`/cards/my-cards/see-card/${getUUIDFromKey(dt.PK)}`} state={{
              ...dt,
              answer: dt.answer,
              categoryPk: dt.category.category,
              title: dt.title,
              PK: dt.PK,
              subcategory: dt.subcategory.name,
              subcategoryPk: dt.subcategory.subcategory,
              category: dt.category.name,
              description: dt.description,
              grade: dt.subcategory.grade,
              subject: dt.category.subject,
            }} >{dt.title}</Link>
          </div>
          , searchableTitle: dt.title,
          editLink: (
            <Link to={`/cards/my-cards/edit-card/${getUUIDFromKey(dt.PK)}`}  >
              <IconButton key={dt.pk}><Icon fontSize="small">edit</Icon></IconButton>
            </Link>
          ),
          removeLink: (
            <IconButton key={dt.pk} onClick={async () => await warningWithConfirmAndCancelMessage(dt.subcategory.subcategory, dt.PK, dt.title)}><Icon fontSize="small">delete</Icon></IconButton>
          )
        }))
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataTableData])

  const handleDeleteQuiz = async (subCategoryId: string, quizId: string, title: string) => {
    try {
      await deleteQuiz(getUUIDFromKey(subCategoryId), getUUIDFromKey(quizId))
      setDataTableData({
        ...dataTableData, rows: dataTableData.rows.filter(dt => dt.PK !== quizId)
      })

      success()

    } catch (error) {
      //@ts-ignore
      handleMessage(error?.response?.data?.message || error?.message, 'error')
    }

  }

  useEffect(() => {
    if (subjectValue) {
      (async () => {
        setCategories(await getMyCategoriesPerSubjectId(subjectValue))
      })()
    }
  }, [subjectValue])

  useEffect(() => {
    if (Object.keys(categoryValue ?? {}).length) {
      (async () => {
        const subcatgs = await getByCategory(getUUIDFromKey(categoryValue.PK))
        setSubCategories(subcatgs)
      })()
    }
  }, [categoryValue, categories])


  const imageConfig = {
    iconFiletypes: ['.jpg', '.png', '.gif'],
    showFiletypeIcon: true,
    postUrl: `https://czy9w4unel.execute-api.eu-west-1.amazonaws.com/images/teste`,
  };

  const audioConfig = {
    iconFiletypes: ['.mp3', '.wav'],
    showFiletypeIcon: true,
    postUrl: 'no-url'
  };

  const getToken = async () => {
    return (await Auth.currentSession()).getIdToken().getJwtToken()
  }

  const djsImageConfig = {
    withCredentials: true,
    maxFiles: 1,
    uploadMultiple: false,
    addRemoveLinks: true,
    acceptedFiles: "image/jpeg,image/png,image/gif",
    autoProcessQueue: false,
    headers: {
      "Access-Control-Allow-Headers": "Content-Type, X-Requested-With, X-PINGOTHER, X-File-Name, Cache-Control",
      "origin": "http://localhost:3000",
      "Cache-Control": "",
      "Authorization": `Bearer ${getToken()}`
    }
  };


  const djsAudioConfig = {
    maxFiles: 1,
    uploadMultiple: false,
    addRemoveLinks: true,
    acceptedFiles: "audio/*",
    autoProcessQueue: false
  };

  const eventDescriptionImageHandlers = {
    init: (e: any) => initDescriptionImageCallback(e),
    addedfile: (file: any) => { setImageDescription(file); setHasDescriptionError(false) },
    maxfilesexceeded: (file: any) => {
      imageDescriptionDropzone.removeAllFiles();
      imageDescriptionDropzone.addFile(file);
      setHasDescriptionError(false);
    },
    removedfile: (file: any) => setImageDescription({} as File)
  }

  const eventDescriptionAudioHandlers = {
    init: (e: any) => initDescriptionAudioCallback(e),
    addedfile: (file: any) => { setAudioDescription(file); setHasDescriptionError(false); },
    maxfilesexceeded: (file: any) => {
      audioDescriptionDropzone.removeAllFiles();
      audioDescriptionDropzone.addFile(file);
      setHasDescriptionError(false);
    },
    removedfile: () => setAudioDescription({} as File)
  }

  const eventAnswerImageHandlers = {
    init: (e: any) => initAnswerImageCallback(e),
    addedfile: (file: any) => { setImageAnswer(file); setHasAnswerError(false); },
    maxfilesexceeded: (file: any) => {
      imageAnswerDropzone.removeAllFiles();
      imageAnswerDropzone.addFile(file);
      setHasAnswerError(false);
    },
    removedfile: () => setImageAnswer({} as File)
  }

  const eventAnswerAudioHandlers = {
    init: (e: any) => initAnswerAudioCallback(e),
    addedfile: (file: any) => { setAudioAnswer(file); setHasAnswerError(false); },
    maxfilesexceeded: (file: any) => {
      audioAnswerDropzone.removeAllFiles();
      audioAnswerDropzone.addFile(file);
      setHasAnswerError(false);
    },
    removedfile: () => setAudioAnswer({} as File)
  }
  // const [hasGradeError, setHasGradeError] = useState(false)
  const [hasSubjectError, setHasSubjectError] = useState(false)
  const [hasCategoryError, setHasCategoryError] = useState(false)
  const [hasSubCategoryError, setHasSubCategoryError] = useState(false)
  const [hasTitleError, setHasTitleError] = useState(false)
  const [hasDescriptionError, setHasDescriptionError] = useState(false)
  const [hasAnswerError, setHasAnswerError] = useState(false)
  const handleCreateQuestion = async (e: FormEvent<HTMLFormElement>) => {
    setIsLoading(true)
    e.preventDefault();
    // if (!gradeValue) {
    //   setHasGradeError(true)
    // }
    if (!subjectValue) {
      setHasSubjectError(true)
    }
    if (!categoryValue) {
      setHasCategoryError(true)
    }
    if (!subCategoryValue) {
      setHasSubCategoryError(true)
    }
    if (!title) {
      setHasTitleError(true)
    }

    if (!eraseRichText(description) && !Object.keys(imageDescription).length && !Object.keys(audioDescription).length) {
      setHasDescriptionError(true)
    }

    if (!eraseRichText(answer) && !Object.keys(imageAnswer).length && !Object.keys(audioAnswer).length) {
      setHasAnswerError(true)
    }

    if (!subjectValue || !categoryValue || !subCategoryValue || !title
      || (!eraseRichText(description) && !Object.keys(imageDescription).length && !Object.keys(audioDescription).length)
      || (!eraseRichText(answer) && !Object.keys(imageAnswer).length && !Object.keys(audioAnswer).length)) {
      setIsLoading(false)
      return
    }
    let quizId: string;
    // let categoryFound: CategoryDto;
    // let subCategoryFound: SubCategoryDto;
    try {
      // if (typeof subCategoryValue === 'string') return
      // subCategoryFound = subCategories.find(c => subCategoryValue.name === c.name)
      // categoryFound = categories.find(c => categoryValue === c.name)
      quizId = await createQuiz(getUUIDFromKey(subCategoryValue.PK), { title, description, answer, category: categoryValue.PK })
    } catch (error) {
      console.log({ error })
      //@ts-ignore
      handleMessage(error?.response?.data?.message || error?.message, 'error')
      return
    }
    try {
      let imageFile
      let audioFile
      let files = [] as { type: string, filepath: string }[]
      let mappedFiles: any[]
      if (Object.keys(imageDescription).length) {
        const { key } = await uploadS3Handler(`${quizId}/`, imageDescription)
        // imgDropzone.processQueue()
        imageFile = `https://quizcards-docs-dev.s3.eu-west-1.amazonaws.com/${quizId}/${key}`
        files = [...files, { type: 'descriptionImage', filepath: imageFile }]
      }
      if (Object.keys(imageAnswer).length) {
        const { key } = await uploadS3Handler(`${quizId}/`, imageAnswer)
        // imgDropzone.processQueue()
        imageFile = `https://quizcards-docs-dev.s3.eu-west-1.amazonaws.com/${quizId}/${key}`
        files = [...files, { type: 'answerImage', filepath: imageFile }]
      }
      if (Object.keys(audioDescription).length) {
        const { key } = await uploadS3Handler(`${quizId}/`, audioDescription)
        // audioDropzone.processQueue()
        audioFile = `https://quizcards-docs-dev.s3.eu-west-1.amazonaws.com/${quizId}/${key}`
        files = [...files, { type: 'descriptionAudio', filepath: audioFile }]
      }
      if (Object.keys(audioAnswer).length) {
        const { key } = await uploadS3Handler(`${quizId}/`, audioAnswer)
        // audioDropzone.processQueue()
        audioFile = `https://quizcards-docs-dev.s3.eu-west-1.amazonaws.com/${quizId}/${key}`
        files = [...files, { type: 'answerAudio', filepath: audioFile }]
      }
      if (files.length) {
        mappedFiles = Object.assign({}, ...files.map(f => ({ [Object.values(f)[0]]: Object.values(f)[1] })))

        const newQuiz = await updateQuiz(getUUIDFromKey(subCategoryValue.PK), quizId, { ...mappedFiles, title, description, answer, category: categoryValue.PK })
        setQuizCards((quizzes: QuizDto[]) => [...quizzes, { ...newQuiz, subcategory: { name: subCategoryValue.name, subcategory: subCategoryValue.PK, grade: subCategoryValue.grade }, category: { name: categoryValue.name, subject: subjectValue, category: categoryValue.PK } }])
        handleMessage('Du har oprettet et nyt spørgsmål', 'success')
        audioDescriptionDropzone.removeAllFiles()
        imageDescriptionDropzone.removeAllFiles()

        audioAnswerDropzone.removeAllFiles()
        imageAnswerDropzone.removeAllFiles()

        setDescription('')
        // setTitle('')
        setAnswer('')
        return
      }
      handleMessage('Du har oprettet et nyt spørgsmål', 'success')
      setQuizCards((quizzes: QuizDto[]) => [...quizzes, { ...mappedFiles, description, title, answer, PK: `QUIZ#${quizId}`, subcategory: { name: subCategoryValue.name, subcategory: subCategoryValue.PK, grade: subCategoryValue.grade }, category: { name: categoryValue.name, subject: subjectValue, grade: subCategoryValue.grade, category: categoryValue.PK } }]);
      setDescription('')
      // setTitle('')
      setAnswer('')
    } catch (error) {
      console.log({ error })
      //@ts-ignore
      handleMessage(error?.response?.data?.message || error?.message, 'error')
    } finally {
      setIsLoading(false)
    }
  }

  const [alert, setAlert] = useState(null)

  const hideAlert = () => {
    setAlert(null);
  };
  const success = () => {
    setAlert(
      //@ts-ignore
      <Alert
        success
        style={{
          display: 'block',
          marginTop: '-100px',
        }}
        title='Slettet!'
        confirmBtnText='Okay'
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
        confirmBtnBsStyle='success'
        btnSize=''
      > Din quiz blev slettet...</Alert>
    );
  };
  const cancel = () => {
    setAlert(
      <Alert
        danger
        style={{
          display: 'block',
          marginTop: '-100px',
        }}
        title='Aflyst'
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
        confirmBtnText='Okay'
        confirmBtnBsStyle='success'
        btnSize=''
      ></Alert>
    );
  };
  const warningWithConfirmAndCancelMessage = (subCategoryId: string, quizId: string, title: string) => {
    setAlert(
      //@ts-ignore
      <Alert
        warning
        style={{
          display: 'block',
          marginTop: '-100px',
        }}
        title='Er du sikker?'
        onConfirm={async () => {
          await handleDeleteQuiz(subCategoryId, quizId, title);
        }}
        onCancel={() => cancel()}
        confirmBtnBsStyle='success'
        cancelBtnBsStyle='danger'
        confirmBtnText='Ja, slet!'
        cancelBtnText='Annullér'
        showCancel
        btnSize=''
      >
        Du vil ikke være i stand til at gendanne din quiz
      </Alert>
    );
  };
  return (
    <DashboardLayout>
      <DashboardNavbar />          {alert}
      <Card >
        <MDBox p={3} lineHeight={1} display='flex' alignItems='center' gap={1}>
          <MDTypography variant="h5" fontWeight="medium">
            Mine kortspørgsmål
          </MDTypography>
          <Typography
            aria-owns={popoverOpen ? 'mouse-over-popover' : undefined}
            aria-haspopup="true"
            onMouseEnter={handlePopoverOpen}
            onMouseLeave={handlePopoverClose}
            style={{
              lineHeight: '1rem',
              cursor: 'pointer',
            }}>
            <Icon>help</Icon>
          </Typography>
          <Popover
            id="mouse-over-popover"
            style={{ pointerEvents: 'none' }}
            PaperProps={{ sx: { backgroundColor: '#fff' } }}
            disableAutoFocus
            disableEnforceFocus
            open={popoverOpen}
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
            onClose={handlePopoverClose}>
              <img src={HelpImage} width={380} alt="quizCategory" />
          </Popover>
        </MDBox>
        <Grid container>
          <Grid style={{ overflowX: 'auto' }} item sm={12} lg={8} >
            {Object.keys(data).length ? <DataTable table={data} canSearch /> : null}
          </Grid>
          <Grid item sm={12} lg={4} >
            <MDBox
              justifyContent='space-between'
              alignItems='center'
              display='flex'
              flexDirection='column'>
              <MDBox mt={1} px={2} width={"100%"}>
                <MDBox mt={1} px={2} max-width={500}>
                  <form onSubmit={handleCreateQuestion}>
                    {/* <Autocomplete
                      aria-required={true}
                      value={gradeValue}
                      getOptionLabel={(option) => option}
                      onChange={(event: any, newValue: string | null) => {
                        setGradeValue(newValue);
                        setHasGradeError(false)
                      }}
                      inputValue={inputGradeValue}
                      onInputChange={(event, newInputValue) => {
                        if (newInputValue === '') {
                          setCategories([])
                          setCategoryValue({} as CategoryDto)
                        }
                        setGradeInputValue(newInputValue);
                      }}
                      id="controllable-states-grades"
                      options={grades}
                      renderInput={(params) => <TextField {...params} label="Klassetrin" />}
                    /> */}
                    {/* {hasGradeError &&
                      <MDTypography variant='h6' fontWeight='regular' color='error'>Vælg klassetrin</MDTypography>} */}
                    <MDBox mt={1}>
                      <Autocomplete
                        noOptionsText="Ingen muligheder endnu"
                        aria-required={true}
                        value={subjectValue}
                        onChange={(event: any, newValue: string) => {
                          setSubjectValue(newValue);
                          setHasSubjectError(false)
                        }}
                        inputValue={inputSubjectValue}
                        onInputChange={(event: any, newInputValue) => {
                          if (newInputValue === '') {
                            setCategories([])
                            setCategoryValue({} as CategoryDto)
                          }
                          setSubjectInputValue(newInputValue);
                        }}
                        id="controllable-states-subjects"
                        options={subjects}
                        renderInput={(params) => <TextField {...params} InputLabelProps={{
                          sx: {
                            color: '#518eb9',
                            fontSize: 25,
                            fontWeight: 1000,
                            "&.MuiOutlinedInput-notchedOutline": { fontSize: 25 }
                          }
                        }} label="Fag/Emner" />}
                      />
                      {hasSubjectError &&
                        <MDTypography variant='h6' fontWeight='regular' color='error'>Vælg fag</MDTypography>}
                    </MDBox>
                    <MDBox mt={1}>
                      <Autocomplete
                        noOptionsText="Ingen muligheder endnu"
                        aria-required={true}
                        getOptionLabel={option => (option as CategoryDto).name}
                        // value={categoryValue}
                        // @ts-ignore
                        onChange={(event: SyntheticEvent<Element, Event>, newValue: CategoryDto | null) => {
                          setCategoryValue(newValue);
                          setHasCategoryError(false)
                        }}
                        inputValue={inputCategoryValue}
                        onInputChange={(event, newInputValue) => {
                          setInputCategoryValue(newInputValue);
                        }}
                        id="controllable-states-subjects"
                        options={categories}
                        renderInput={(params) => <TextField {...params} InputLabelProps={{
                          sx: {
                            color: '#518eb9',
                            fontSize: 25,
                            fontWeight: 1000,
                            "&.MuiOutlinedInput-notchedOutline": { fontSize: 25 }
                          }
                        }} label="Hovedkategori" />}
                      />
                      {hasCategoryError &&
                        <MDTypography variant='h6' fontWeight='regular' color='error'>Vælg kategori</MDTypography>}
                    </MDBox>
                    <MDBox mt={1}>
                      <Autocomplete
                        noOptionsText="Ingen muligheder endnu"
                        aria-required={true}
                        getOptionLabel={option => (option as SubCategoryDto).name}
                        // value={subCategoryValue as SubCategoryDto } 
                        // @ts-ignore
                        onChange={(event: SyntheticEvent<Element, Event>, newValue: SubCategoryDto | null) => {
                          setSubCategoryValue(newValue);
                          setHasSubCategoryError(false)
                        }}
                        inputValue={inputSubCategoryValue}
                        onInputChange={(event, newInputValue) => {
                          setInputSubCategoryValue(newInputValue);
                        }}
                        id="controllable-states-subjects"
                        options={subCategories}
                        renderInput={(params) => <TextField {...params} InputLabelProps={{
                          sx: {
                            color: '#518eb9',
                            fontSize: 25,
                            fontWeight: 1000,
                            "&.MuiOutlinedInput-notchedOutline": { fontSize: 25 }
                          }
                        }} label="Quiz-kategori" />}
                      />
                      {hasSubCategoryError &&
                        <MDTypography variant='h6' fontWeight='regular' color='error'>Vælg Quiz-kategori</MDTypography>}
                    </MDBox>
                    <MDBox mt={1}>
                      <Card>
                        <MDBox>
                          <TextField
                            aria-required
                            fullWidth
                            label="Titel"
                            InputLabelProps={{
                              sx: {
                                color: '#518eb9',
                                fontSize: 25,
                                fontWeight: 1000,
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: 25 }
                              }
                            }}
                            value={title}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                              setHasTitleError(false)
                              setTitle(e.target.value)
                            }}
                          />
                          {hasTitleError &&
                            <MDTypography variant='h6' fontWeight='regular' color='error'>Skriv en titel</MDTypography>}
                        </MDBox>
                        <MDBox
                          marginTop={2}
                          paddingBottom={2}
                          borderRadius='45px'
                          border='0.3em solid #7030a0'
                        >
                          <MDBox mt={1} px={2}>
                            <MDTypography
                              style={{
                                color: '#518eb9',
                                fontSize: 25,
                                fontWeight: 1000
                              }}
                              variant='h6' fontWeight='light'
                            >
                              Quiz-spørgsmål
                            </MDTypography>
                            <MDEditor
                              cardsLength={quizCards.length}
                              aria-required={true}
                              value={description}
                              onChange={(description: string) => {
                                setHasDescriptionError(false)
                                setDescription(description)
                              }}
                              theme="snow"
                            />
                          </MDBox>
                          <Grid container>
                            <Grid item sm={6} md={6} lg={12} xl={6} >
                              <MDBox mt={1} px={2}>
                                <MDTypography variant='h6' fontWeight='light'>Vælg et billede til beskrivelsen</MDTypography>
                                {/*@ts-ignore */}
                                <DropzoneComponent
                                  eventHandlers={eventDescriptionImageHandlers}
                                  config={imageConfig}
                                  djsConfig={djsImageConfig}
                                >
                                  <div className="dz-message" data-dz-message><span>Slip fil her for at uploade</span></div>
                                </DropzoneComponent>

                              </MDBox></Grid>
                            <Grid item sm={6} md={6} lg={12} xl={6} >
                              <MDBox mt={1} px={2}>
                                <MDTypography variant='h6' fontWeight='light'>Vælg en lydfil til beskrivelsen</MDTypography>
                                {/*@ts-ignore */}
                                <DropzoneComponent
                                  eventHandlers={eventDescriptionAudioHandlers}
                                  config={audioConfig}
                                  djsConfig={djsAudioConfig}
                                >
                                  <div className="dz-message" data-dz-message><span>Slip fil her for at uploade</span></div>
                                </DropzoneComponent>

                              </MDBox>
                            </Grid>
                            {hasDescriptionError &&
                              <MDTypography variant='h6' marginLeft={2} fontWeight='regular' color='error'>Lav en beskrivelse</MDTypography>}
                          </Grid>
                        </MDBox>
                        <MDBox
                          marginTop={2}
                          paddingBottom={2}
                          borderRadius='45px'
                          border='0.3em solid #ed7d31'
                        >
                          <MDBox mt={1} px={2}>
                            <MDTypography
                              style={{
                                color: '#518eb9',
                                fontSize: 25,
                                fontWeight: 1000
                              }}
                              variant='h6'
                              fontWeight='light'>
                              Svar på Quizspørgsmålet
                            </MDTypography>
                            <MDEditor
                              cardsLength={quizCards.length}
                              value={answer} onChange={(answer: string) => {
                                setHasAnswerError(false)
                                setAnswer(answer)
                              }} />
                          </MDBox>
                          <Grid container>
                            <Grid item sm={6} md={6} lg={12} xl={6} >
                              <MDBox mt={1} px={2}>
                                <MDTypography variant='h6' fontWeight='light'>Vælg et billede til svaret</MDTypography>
                                {/*@ts-ignore */}
                                <DropzoneComponent
                                  eventHandlers={eventAnswerImageHandlers}
                                  config={imageConfig}
                                  djsConfig={djsImageConfig}
                                >
                                  <div className="dz-message" data-dz-message><span>Slip fil her for at uploade</span></div>
                                </DropzoneComponent>

                              </MDBox></Grid>
                            <Grid item sm={6} md={6} lg={12} xl={6}>
                              <MDBox mt={1} px={2}>
                                <MDTypography variant='h6' fontWeight='light'>Vælg en lydfil til svaret</MDTypography>
                                {/*@ts-ignore */}
                                <DropzoneComponent
                                  eventHandlers={eventAnswerAudioHandlers}
                                  config={audioConfig}
                                  djsConfig={djsAudioConfig}
                                >
                                  <div className="dz-message" data-dz-message><span>Slip fil her for at uploade</span></div>
                                </DropzoneComponent>

                              </MDBox>
                            </Grid>
                            {hasAnswerError &&
                              <MDTypography variant='h6' marginLeft={2} fontWeight='regular' color='error'>Skriv en svar</MDTypography>}

                          </Grid>
                        </MDBox>
                        <MDBox p={3} px={10} mx='auto'>
                          {<MDButton disabled={isLoading} type='submit' color='info'>{isLoading && <CircularProgress style={{ marginRight: 5 }} color='error' size={20} />} Opret Quiz</MDButton>}
                        </MDBox>
                      </Card>
                    </MDBox>
                  </form>
                </MDBox>
              </MDBox>
            </MDBox>
          </Grid>

        </Grid>
      </Card >
    </DashboardLayout >
  );
}


export default Cards;
